/**
 * Created by Ivan on 25.05.2025
 */

const JackpotTutorial = function () {
    return new TutorialScenario(JackpotTutorial.NAME, {
        listSteps: () => [
            JackpotTutorial.addJackpotStep(),
            TileGameTutorialHelper.createPlayCardStep(JackpotTutorial.CONFIG.tutorial[0])
        ],

        onStart: function () {
            Game.currentGame.shownTutorials.push(JackpotTutorial.NAME);
            Game.currentGame.hand.setCards(JackpotTutorial.CONFIG.handValues);
        },

        isAvailable: () => TileGameTutorialHelper.isAvailable(JackpotTutorial.NAME)
    });
};

JackpotTutorial.addJackpotStep = () => new TutorialStep({
    onStart: function () {
        const data = JackpotTutorial.CONFIG.tutorial[0];
        const openCards = Game.currentGame.table.listOpen()
            .filter((openCard) => TileGameTutorialHelper.isApplicable(openCard, data.filter), this)
            .map((card) => card.onGetView());

        const jackpotCard = openCards.filter((openCard) => Card.VALUES.indexOf(data.filter[0].toLowerCase()) === openCard.card.getCardValue())[0];
        Game.currentGame.addJackpot(() => {
            Game.currentGame.counter.setTimeout(() => {
                this.finish();
            }, Card.PLAY_TIMEOUT * 1000);
        }, jackpotCard.card);
    },
    onFinish: function () {}
});

JackpotTutorial.NAME = "jackpot";
JackpotTutorial.CONFIG = {
    handValues: ["j"],
    tutorial: [{
        type: JackpotTutorial.NAME,
        force: "JackpotTutorialMessage",
        filter: ["t"]
    }]
};
